import React, { lazy } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AppShell from "./AppShell";
import Landing from "./routes/Landing";

/**
 * V0.2 router root. Project-first IA: landing at `/`, per-project workspace at
 * `/p/:projectId`. Route components are React.lazy code-split so the heavy
 * deck.gl / MapLibre / three dependencies load per-route instead of in the
 * initial bundle (the Suspense boundary lives around AppShell's <Outlet>).
 * AppShell + Landing stay eager so `/` paints without a chunk fetch.
 *
 * NOTE (prod): BrowserRouter needs an SPA history fallback (serve index.html
 * for unknown paths). Vite dev provides this; wire a Flask catch-all when the
 * built SPA is served from the backend.
 */
const ProjectWorkspace = lazy(() => import("./routes/ProjectWorkspace"));
const Ledger = lazy(() => import("./routes/Ledger"));
const Library = lazy(() => import("./routes/Library"));
const Doctor = lazy(() => import("./routes/Doctor"));
const Ramps = lazy(() => import("./routes/Ramps"));
const Bridges = lazy(() => import("./routes/Bridges"));
const GisImport = lazy(() => import("./routes/GisImport"));
const CadToBim = lazy(() => import("./routes/CadToBim"));
const PdfStaging = lazy(() => import("./routes/PdfStaging"));
const AssetBuilder = lazy(() => import("./routes/AssetBuilder"));
const Projects = lazy(() => import("./routes/Projects"));
const Forge = lazy(() => import("./routes/Forge"));
const Pavement = lazy(() => import("./routes/Pavement"));
const Markings = lazy(() => import("./routes/Markings"));
const Curb = lazy(() => import("./routes/Curb"));
const Linear = lazy(() => import("./routes/Linear"));
const CorridorImport = lazy(() => import("./routes/CorridorImport"));
const FieldCapture = lazy(() => import("./routes/FieldCapture"));
const ImportDispatcher = lazy(() => import("./routes/ImportDispatcher"));
const BridgeInspector = lazy(() => import("./routes/BridgeInspector"));

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AppShell />}>
          <Route index element={<Landing />} />
          <Route path="p/:projectId" element={<ProjectWorkspace />} />
          <Route path="p/:projectId/import/:source" element={<ImportDispatcher />} />
          <Route path="ledger" element={<Ledger />} />
          <Route path="ramps" element={<Ramps />} />
          <Route path="bridges" element={<Bridges />} />
          <Route path="library" element={<Library />} />
          <Route path="doctor" element={<Doctor />} />
          <Route path="gis" element={<GisImport />} />
          <Route path="cad" element={<CadToBim />} />
          <Route path="staging" element={<PdfStaging />} />
          <Route path="builder" element={<AssetBuilder />} />
          <Route path="projects" element={<Projects />} />
          <Route path="forge" element={<Forge />} />
          <Route path="pavement" element={<Pavement />} />
          <Route path="markings" element={<Markings />} />
          <Route path="curb" element={<Curb />} />
          <Route path="linear" element={<Linear />} />
          <Route path="corridor" element={<CorridorImport />} />
          <Route path="photo" element={<FieldCapture />} />
          <Route path="bridge/:bridgeId" element={<BridgeInspector />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
